import React from 'react'
import Style from './Top.module.css'

const Wrapper = ({ children }) => {
  return <div className="wrapper">{ children }</div>;
};

const Topbtn = () => {

  const gotoBtn = () => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" })
  }
  return (
    <>

         <button className={ Style.buttan } onClick={ gotoBtn }><i class="fa-solid fa-arrow-up"></i> top </button> 

      
    </>
  )

}



export default Topbtn
